/* global System */

export default {
  EstateSearchBox: () =>
    System.import(/* webpackChunkName: "EstateSearchBox" */ './index'),
}
